module.exports = __webpack_public_path__ + "assets/media/morning.80c0674c.mp3";